import React, { Component } from 'react'
import Actions from './common/Actions'
import Menu from './frame/FrameMenu'

const Frame = (props) => {
  let {
    frame,
    originalImage,
    onFrameUpdated
  } = props

  return (
    <div className="frame">
      <Actions
        {...props}
      />
      <div className="">
        <Menu
          frame={frame}
          originalImage={originalImage}
          onFrameUpdated={onFrameUpdated}
        />
      </div>
    </div>
  )
}

export default Frame
